export default "__VITE_ASSET__DAVn8wYi__"